import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Jornada} from "../../../domain/Jornada";
@Injectable()
export class JornadaHttpService  extends AbstractHttpService<Jornada>{
    url = '/api/jornada';
}
